<template>
  <div>
    <v-layout v-if="!isEdit">
      <v-flex class="pa-2">
        <v-layout>
          <v-flex shrink>
            <v-chip small color="primary" class="white--text mr-2" disabled>{{
              api.api_method
            }}</v-chip>
          </v-flex>
          <v-flex>
            {{ api.api_name }}
            <div class="caption grey--text">{{ description }}</div>
          </v-flex>
        </v-layout>
      </v-flex>
      <template
        v-if="
          $store.state.superadmin.includes($store.state.userid) ||
            (api.id &&
              (api.owneradminid == $store.state.userid || api.createdby == $store.state.userid))
        "
      >
        <v-btn fab small depressed color="primary" @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn fab small depressed color="primary" @click="$emit('onDelete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
    </v-layout>
    <template v-else>
      <div class="pa-2">
        <div class="form-control">
          <input type="text" placeholder="Name" v-model="api.api_name" />
        </div>
        <div class="form-control">
          <textarea placeholder="Description" v-model="description" style="width: 100%"></textarea>
        </div>
        <v-layout>
          <v-flex class="pr-1" style="max-width: 120px">
            <multiselect
              v-model="api.api_method"
              :options="['GET', 'POST', 'PUT', 'DELETE']"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
            ></multiselect>
          </v-flex>
          <v-flex class="pl-1">
            <div class="form-control">
              <input type="text" placeholder="url" v-model="api.api_url" />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <div class="pa-2">
        <h3 class="primary--text mt-3 mb-2">Request</h3>
        <div>Query Prameters</div>
        <v-layout v-for="(query, qindex) in request" :key="qindex">
          <v-flex class="form-control pa-1">
            <input type="text" placeholder="Variable name" v-model="query.name" />
          </v-flex>
          <v-flex class="form-control pa-1">
            <input type="text" placeholder="Description" v-model="query.possible_output" />
          </v-flex>
          <v-btn fab small color="primary" depressed @click="onDeleteQuery(qindex)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-layout>

        <div class="add-conversation text-xs-center" style="cursor: pointer" @click="onAddQuery">
          <i class="fa fa-plus middle"></i>
          {{ $t('Add variable') }}
        </div>

        <template v-if="api.api_method !== 'GET'">
          <div class="mt-2">Body</div>
          <div>
            <multiselect
              :options="variableOptions"
              placeholder="Select variable"
              @input="handleBodyVariableInput"
            />
            <CodeMirror ref="editor" v-model="api.api_data_format" />
            <!-- <textarea style="width: 100%; min-height: 90px" v-model="api.api_data_format"></textarea> -->
          </div>
        </template>
      </div>
      <v-divider></v-divider>
      <div class="pa-2">
        <h3 class="primary--text mt-3 mb-2">Response</h3>

        <v-layout v-for="(res, rindex) in response" :key="rindex">
          <v-flex class="form-control pa-1">
            <input type="text" placeholder="Variable name" v-model="res.name" />
          </v-flex>
          <v-flex class="form-control pa-1">
            <input type="text" placeholder="Posibile Output" v-model="res.possible_output" />
            <input type="text" placeholder="Description" v-model="res.description" />
          </v-flex>

          <v-btn fab small color="primary" depressed @click="onDeleteResponse(rindex)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-layout>

        <div class="add-conversation text-xs-center" style="cursor: pointer" @click="onAddResponse">
          <i class="fa fa-plus middle"></i>
          {{ $t('Add variable') }}
        </div>
      </div>
      <v-divider></v-divider>
      <div class="pa-2 text-xs-center">
        <v-btn color="grey" outline @click="onCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import CodeMirror from '@/components/elements/CodeMirror'
export default {
  props: ['value'],
  data() {
    return {
      api: {
        api_method: 'GET',
        api_response: ''
      },
      isEdit: false,
      request: [],
      response: [],
      description: ''
    }
  },
  mounted() {
    if (this.value) {
      this.api = this.value
      this.resetQueryAndResponse(this.api)
    } else {
      this.isEdit = true
    }
    this.cached_api = JSON.stringify(this.api)
  },
  components: {
    Multiselect,
    CodeMirror
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      return vm.variable.filter(el => {
        return el.flowid == 0 || (vm.selectedFlow && el.flowid == vm.selectedFlow.id)
      })
    },
    variableOptions() {
      return Array.from(new Set(this.variable.map(v => v.name)))
    }
  },
  methods: {
    resetQueryAndResponse(api) {
      try {
        this.request =
          api.api_req_format != '' && api.api_req_format != null
            ? JSON.parse(api.api_req_format)
            : []
      } catch (error) {
        this.request = []
      }
      this.description = api.description
      try {
        this.response =
          api.api_res_format != '' && api.api_res_format != null
            ? JSON.parse(api.api_res_format)
            : []
      } catch (error) {
        this.response = []
      }
    },
    onCancel() {
      this.$emit('onCancel')
      this.isEdit = false
      this.api = JSON.parse(this.cached_api)
      this.resetQueryAndResponse(this.api)
    },
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }
        var data = vm.api
        data.api_req_format = JSON.stringify(vm.request)
        data.api_res_format = JSON.stringify(vm.response)
        if (vm.variable.id) {
          data.id = vm.api.id
        }
        data.description = vm.description
        vm.$emit('onSave', data)
        vm.api = data
        vm.cached_api = JSON.stringify(data)
        this.resetQueryAndResponse(this.api)
        vm.isEdit = false
      })
    },
    onAddQuery() {
      this.request.push({
        name: '',
        possible_output: ''
      })
    },
    onDeleteQuery(index) {
      this.request.splice(index, 1)
    },
    onAddResponse() {
      this.response.push({
        name: '',
        possible_output: '',
        description: ''
      })
    },
    onDeleteResponse(index) {
      this.response.splice(index, 1)
    },
    handleBodyVariableInput(value) {
      const pos = this.$refs.editor.instance.doc.getCursor()
      this.$refs.editor.instance.doc.replaceRange(`{${value}}`, pos)
      this.$refs.editor.instance.focus()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/AddApi.vue